import React from "react";

export default function Function() {

    return (
        <div className="c-light-2">
            <h1 className="text-center pad-top-4">Magikus</h1>
            <h6 className="ts-i text-center pad-bottom-3 c-light-4 ft-secondary">
                License
            </h6>
            <p>
                Copyright (c) 2022 Magikus Studios. All Rights Reserved.
            </p>
            <p>
                Licensed under the Unity
                <a className="t-dec-none c-light-0 c-light-4-h" href="https://unity3d.com/legal/as_terms" target="_blank" rel="noopener noreferrer"> Asset Store Terms of Service and EULA</a>.
            </p>
            <p>
                Unless expressly provided otherwise,
                the Software under this license is made available strictly on an "AS IS" BASIS WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED.
                Please review the license for details on these and other terms and conditions.
            </p>
        </div>
    );
}